<div class="content-card mat-white-bg">

  <mat-table class="products-table"
    #table [dataSource]="users"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>


    <ng-container cdkColumnDef="color">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <div class="color" [style.borderTopColor]="user.event.eventType.color"></div>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="eventTitle">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.title' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user.eventTitle}}</p>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="eventType">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.eventType' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <div class="color" [style.borderTopColor]="user.eventType.color"></div>
        @if (user.type !== 'manual') {
          <p class="text-truncate">{{user.eventType.name}}</p>
        }
        @if (user.type === 'manual') {
          <p class="text-truncate">{{user.eventType.name}}</p>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="type">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'frontUser.type' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate">{{user.type}}</p>
      </mat-cell>
    </ng-container>

    <ng-container cdkColumnDef="credits">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.credits' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.credits > 0) {
          <p class="text-truncate plus-cretit" >{{user.credits}}</p>
        }
        @if (user.credits <= 0) {
          <p class="text-truncate minus-credit" >{{user.credits}}</p>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="comment">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.title' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        <p class="text-truncate"  matTooltip="{{user.comment}}">{{user.comment}}</p>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="action">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *cdkCellDef="let user">
        @if (user.type !== 'code') {
          <button mat-icon-button (click)="deleteReward($event, user.id)">
            <mat-icon >delete</mat-icon>
          </button>
        }
      </mat-cell>
    </ng-container>



    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let user; columns: displayedColumns;"
      class="product"
      matRipple>
    </mat-row>

  </mat-table>

  <mat-paginator #paginator
    [length]="users.filteredData.length"
    [pageIndex]="0"
    [pageSize]="50"
    [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>

</div>
